// Lesson 2: Menyebutkan Asal - Question Configurations
export interface QuestionConfig {
    type: string;
    wordBank: number[]; // Word IDs to use
    questionSentence?: number[]; // Order of word IDs for sentence questions
    correctAnswer?: number[] | number; // Correct answer(s)
    options?: Array<{ id: number; text?: string }>; // Multiple choice options
    imagePrompt?: string; // For image-based questions
}

export interface MatchingPair {
    indonesian: string;
    batak: string;
}

// Vocabulary introduction configurations
export const unit1Lesson2VocabIntroConfigs = [
    {
        type: "vocab-intro",
        introWordId: 201, // Asal
    },
    {
        type: "vocab-intro",
        introWordId: 202, // Sai do (Dari mana)
    },
    {
        type: "vocab-intro",
        introWordId: 203, // Au do martonun (Saya dari)
    },
    {
        type: "vocab-intro",
        introWordId: 205, // Huta (Kampung)
    },
    {
        type: "vocab-intro",
        introWordId: 204, // Medan
    }
];

// Fill in the blank configurations
export const unit1Lesson2FillInBlankConfigs: QuestionConfig[] = [
    {
        // Fill in the blank for "Dari mana asalmu?"
        type: "fill-in-the-blank",
        wordBank: [201, 202, 203, 204, 205, 206, 207, 208, 105, 209],
        questionSentence: [999, 106, 202, 998], // "___ do asalmu?"
        correctAnswer: 201, // martonun
        options: [
            { id: 201 }, // martonun
            { id: 207 }, // Porsea
            { id: 208 }, // Tarutung
            { id: 204 }  // Medan
        ]
    },
    {
        // Fill in the blank for "Saya dari Balige"
        type: "fill-in-the-blank",
        wordBank: [201, 202, 203, 204, 205, 206, 207, 208, 105, 209],
        questionSentence: [105, 999, 206], // "Au _____ Balige"
        correctAnswer: 209, // do
        options: [
            { id: 209 }, // do
            { id: 210 }, // Tanah
            { id: 202 }, // Sai do
            { id: 205 }  // Huta
        ]
    },
    {
        // Fill in the blank for "Apakah Kaido Berasal Dari Tanah Damai?"
        type: "fill-in-the-blank",
        wordBank: [201, 202, 203, 204, 205, 206, 207, 208, 105, 209],
        questionSentence: [214, 113, 213, 209, 999, 211, 998], // "manang Kaido marabona do tano dame?"
        correctAnswer: 210, // Tanah
        options: [
            { id: 210 }, // Tanah
            { id: 201 }, // Asal
            { id: 202 }, // Sai do
            { id: 205 }  // Huta
        ]
    },
    {
        // Fill in the blank for "Saya dari Negara Damai"
        type: "fill-in-the-blank",
        wordBank: [201, 202, 203, 204, 205, 206, 207, 208, 105, 209],
        questionSentence: [105, 999, 210, 211], // "au do nagara dame" -> Sai do asal
        correctAnswer: 209, // Sai do
        options: [
            { id: 209 }, // Sai do
            { id: 202 }, // Au
            { id: 203 }, // Au do martonun
            { id: 201 }  // do
        ]
    },
    {
        // Fill in the blank for "Apakah Kaido Berasal Dari Tanah Damai?"
        type: "fill-in-the-blank",
        wordBank: [201, 202, 203, 204, 205, 206, 207, 208, 105, 209],
        questionSentence: [214, 113, 999, 209, 210, 211, 998], // "manang Kaido marabona do tano dame?"
        correctAnswer: 213, // do
        options: [
            { id: 213 }, // do
            { id: 201 }, // Asal
            { id: 202 }, // Sai do
            { id: 205 }  // Huta
        ]
    },
];

// Compose sentence configurations
export const unit1Lesson2ComposeSentenceConfigs: QuestionConfig[] = [
    {
        type: "compose-sentences",
        wordBank: [105, 209, 206, 201, 202], // au, do, martonun, Balige
        questionSentence: [105, 209, 206], // "Au do martonun Balige"
        correctAnswer: [105, 209, 206]
    },
    {
        type: "compose-sentences",
        wordBank: [202, 205, 207, 209, 201, 106], // Sai do, asal, ho
        questionSentence: [202, 201, 106, 998], // "Sai do asal ho"
        correctAnswer: [202, 201, 106]
    },
    {
        type: "compose-sentences",
        wordBank: [214, 201, 202, 106, 213, 204, 209, 205], // manang, ho, marabona, do, huta
        questionSentence: [214, 106, 213, 209, 205, 998], // "Manang ho marabona do huta"
        correctAnswer: [214, 106, 213, 209, 205]
    },
    {
        type: "compose-sentences",
        wordBank: [113, 201, 213, 202, 209, 210, 204, 211], // Kaido, do, marabona, do, tano, dame
        questionSentence: [113, 213, 209, 210, 211], // "Kaido marabona do tano dame"
        correctAnswer: [113, 213, 209, 210, 211]
    },
    {
        type: "compose-sentences",
        wordBank: [107, 205, 209, 203, 201, 208], // ia, do, martonun, Tarutung
        questionSentence: [107, 209, 208], // "Ia do martonun Tarutung"
        correctAnswer: [107, 209, 208]
    }
];

// Word translation configurations
export const unit1Lesson2WordTranslationConfigs = [
    {
        type: "word-translation",
        wordBank: [201],
        correctAnswer: 201, // Asal
        options: [
            { id: 201, text: "Asal" },
            { id: 202, text: "Dari mana" },
            { id: 203, text: "Saya dari" },
            { id: 204, text: "Medan" }
        ]
    },
    {
        type: "word-translation",
        wordBank: [205],
        correctAnswer: 205, // Kampung/Huta
        options: [
            { id: 205, text: "Kampung" },
            { id: 206, text: "Balige" },
            { id: 207, text: "Porsea" },
            { id: 208, text: "Tarutung" }
        ]
    },
    {
        type: "word-translation",
        wordBank: [202],
        correctAnswer: 202, // Sai do
        options: [
            { id: 202, text: "Dari mana" },
            { id: 105, text: "Saya" },
            { id: 203, text: "Saya dari" },
            { id: 209, text: "dari" }
        ]
    },
    {
        type: "word-translation",
        wordBank: [204],
        correctAnswer: 204, // Balige
        options: [
            { id: 206, text: "Balige" },
            { id: 204, text: "Medan" },
            { id: 207, text: "Porsea" },
            { id: 208, text: "Tarutung" }
        ]
    },
    {
        type: "word-translation",
        wordBank: [206],
        correctAnswer: 206, // Balige
        options: [
            { id: 207, text: "Porsea" },
            { id: 204, text: "Medan" },
            { id: 206, text: "Balige" },
            { id: 208, text: "Tarutung" }
        ]
    }
];

// Word matching pairs
export const unit1Lesson2WordMatchingPairs: MatchingPair[] = [
    { indonesian: "Asal", batak: "ᯀᯘᯇ" },
    { indonesian: "Dari mana", batak: "ᯘᯀᯤ ᯑᯬ" },
    { indonesian: "Saya dari", batak: "ᯀᯮ ᯑᯬ" },
    { indonesian: "Kampung", batak: "ᯂᯮᯖ" },
    { indonesian: "Medan", batak: "ᯔᯉ" },
    { indonesian: "dari", batak: "ᯑᯬ" }
];

// Matching words configuration
export const unit1Lesson2MatchingWordsConfig = {
    type: "matching-words",
    pairs: unit1Lesson2WordMatchingPairs,
};

// Question types for lesson 2 (only those with existing components)
export const unit1Lesson2QuestionTypes = [
    "vocab-intro",
    "fill-in-the-blank",
    "compose-sentences",
    "word-translation",
    "matching-words"
];
